import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { LogIn, Loader2, AlertCircle } from 'lucide-react';

interface SignInButtonProps {
  className?: string;
}

export const SignInButton: React.FC<SignInButtonProps> = ({ className = '' }) => {
  const { signIn, loading } = useAuth();
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSignIn = async () => {
    try {
      setError(null);
      setIsSigningIn(true);
      await signIn();
    } catch (error: any) {
      console.error('Sign in failed:', error);
      setError(error.message || 'Sign in failed');
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <div className="flex flex-col items-end">
      <button
        onClick={handleSignIn}
        disabled={loading || isSigningIn}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      >
        {loading || isSigningIn ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : (
          <LogIn className="w-5 h-5" />
        )}
        <span className="text-sm font-medium">
          {loading || isSigningIn ? 'Signing in...' : 'Sign in with Google'}
        </span>
      </button>
      
      {error && (
        <div className="mt-2 flex items-center gap-1 text-xs text-red-600 max-w-xs">
          <AlertCircle className="w-3 h-3 flex-shrink-0" />
          <span className="truncate">{error}</span>
        </div>
      )}
    </div>
  );
};
